import { render, staticRenderFns } from "./registered.vue?vue&type=template&id=48fc1c84&scoped=true&"
import script from "./registered.vue?vue&type=script&lang=js&"
export * from "./registered.vue?vue&type=script&lang=js&"
import style0 from "./registered.vue?vue&type=style&index=0&id=48fc1c84&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc1c84",
  null
  
)

export default component.exports